import React from 'react';
import styles from './Info.module.css';
import ReactMarkdown from 'react-markdown';

export default function Info({ info }) {
  return (
    <div className={styles.info}>
      <ReactMarkdown skipHtml={true}>{info}</ReactMarkdown>
    </div>
  );
}
